import { FunctionComponent, useContext, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'

import CheckmarkIcon from 'components/SVG/Checkmark'

interface IHeightProps {
  height?: number | string
}
const RelativeContainer = styled.div<IHeightProps>`
  position: relative;
  z-index: 0;
  height: ${props => props.height};
  overflow: hidden;
  transition: height 250ms;
`

const BackingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${props => props.theme.colors.transparent};
  z-index: -1;
`

interface ICenteredProps {
  centered?: boolean
}
interface IFlatBottomProps {
  flatBottom?: boolean
}
interface INoRadiusProps {
  noRadius?: boolean
}
interface IPaddingProps {
  extraPadding?: boolean
}
const Container = styled.div<
  ICenteredProps & IFlatBottomProps & IHeightProps & INoRadiusProps & IPaddingProps
>`
  padding: ${props => (props.extraPadding ? '20px' : '10px 12px')};
  background: ${props => props.theme.colors.transparentPurpleAlpha10};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: ${props => (props.centered ? 'center' : 'flex-start')};
  width: 100%;
  z-index: 200;

  ${props =>
    props.flatBottom
    && `
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  `}
  ${props => props.noRadius && 'border-radius: 0;'}
  ${props => props.height && `height: ${props.height}px`}
`

const IconContainer = styled.div`
  margin-right: 10px;
  height: 24px;
  width: 24px;
`

const SuccessText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;

  color: ${props => props.theme.colors.blue8};
  z-index: 200;
`

interface IProps {
  banner?: boolean
  centered?: boolean
  message?: string | undefined
  flatBottom?: boolean
  noRadius?: boolean
  dismissAfter?: number
}

const SuccessBox: FunctionComponent<IProps> = ({
  banner,
  centered,
  message,
  flatBottom,
  noRadius,
  dismissAfter,
}) => {
  if (!message) return null

  const theme = useContext(ThemeContext)
  const [open, setOpen] = useState(true)

  if (dismissAfter) {
    setTimeout(() => {
      setOpen(false)
    }, dismissAfter)
  }

  return (
    <RelativeContainer height={open ? '44px' : '0px'}>
      <Container
        centered={centered}
        extraPadding={banner}
        flatBottom={flatBottom}
        noRadius={noRadius}
      >
        <IconContainer>
          <CheckmarkIcon
            height={24}
            width={24}
            fill={theme.colors.blue8}
          />
        </IconContainer>
        <SuccessText>{message}</SuccessText>
      </Container>
      <BackingContainer />
    </RelativeContainer>
  )
}

export default SuccessBox
